import { IFullPlanDetailPPO } from "../../../interfaces/api";
import { getDoubleDeepPPO, getTierPPO } from "../../../functions/planDetails";
import DoubleInfoBenefit from "./DoubleInfoBenefit.component";
import PPODoubleDeepInfoBenefit from "./PPODoubleDeepInfoBenefit.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const PPODataTableDetailSPrescriptions = ({
  data,
}: {
  data: IFullPlanDetailPPO;
}) => {
  const { selectedYear } = useZipRootLoaderData();
  const getPartDPPOBenefit =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Part D Deductible",
          "Part D Deductible In Network Standard Medicare-defined"
        )
      : getDoubleDeepPPO(
          data,
          "Part D Deductible",
          "Part D Deductible in network standard medicare-defined"
        );
  const getInitialCoveragePPOBenefit = getDoubleDeepPPO(
    data,
    "Initial Coverage Limit",
    "Initial Coverage Limit"
  );
  const getPartDOutPPOBenefit =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Part D Out of Pocket Threshold",
          "Part D Out Of Pocket Threshold"
        )
      : getDoubleDeepPPO(
          data,
          "Part D Out of Pocket Threshold",
          "Part D Out of Pocket Threshold"
        );
  const tier1 = getTierPPO(data, "Preferred Generic Drugs");
  const tier2 = getTierPPO(data, "Generic Drugs");
  const tier3 = getTierPPO(data, "Preferred Brand Drugs");
  const tier4 =
    selectedYear === 2024
      ? getTierPPO(data, "Non-Preferred Drugs")
      : getTierPPO(data, "Non-Preferred Brand Drugs");
  const tier5 = getTierPPO(data, "Specialty Tier Drugs");
  const tier6 = getTierPPO(data, "Select Care Drugs");

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <PPODoubleDeepInfoBenefit
        benefit={getPartDPPOBenefit}
        title="Part D Deductible"
      />
      <PPODoubleDeepInfoBenefit
        benefit={getInitialCoveragePPOBenefit}
        title="Initial Coverage Limit"
      />
      <PPODoubleDeepInfoBenefit
        benefit={getPartDOutPPOBenefit}
        title="Part D Out-of-Pocket Threshold"
      />
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          Tiers
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          Retail Standard
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          Mail Order Standard
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Tiers
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Retail Standard
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Mail Order Standard
        </div>
      </div>
      <DoubleInfoBenefit benefit={tier1} title="Tier 1: Preferred Generic" />
      <DoubleInfoBenefit benefit={tier2} title="Tier 2: Generic" />
      <DoubleInfoBenefit benefit={tier3} title="Tier 3: Preferred Brand" />
      <DoubleInfoBenefit benefit={tier4} title="Tier 4: Non-Preferred" />
      <DoubleInfoBenefit benefit={tier5} title="Tier 5: Specialty Tier" />
      <DoubleInfoBenefit benefit={tier6} title="Tier 6: Select Care" />
    </div>
  );
};

export default PPODataTableDetailSPrescriptions;
